const URL_RE = /((?:https?:\/\/|www\.)[^\s<>"']+)/gi;

export default function LinkifiedText({ text, className = "", linkClassName = "" }) {
  const value = String(text || "");
  if (!value) return null;
  const parts = value.split(URL_RE);
  return (
    <div className={`whitespace-pre-wrap break-words leading-relaxed ${className}`}>
      {parts.map((part, index) => {
        if (!URL_RE.test(part)) {
          URL_RE.lastIndex = 0;
          return part;
        }
        URL_RE.lastIndex = 0;
        const href = part.toLowerCase().startsWith("http") ? part : `https://${part}`;
        return (
          <a
            key={`${part}-${index}`}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className={`font-bold underline decoration-current/40 underline-offset-2 hover:decoration-current ${linkClassName}`}
            onClick={(event) => event.stopPropagation()}
          >
            {part}
          </a>
        );
      })}
    </div>
  );
}
